import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithTokenRefresh } from '../../common/baseQuery'
import { BasePageRequest, BasePageResponse, BaseRequest, BaseResponse } from '../models'
import { EventFilter, EventFilterConditionOperatorType, EventFilterConditionType, EventFilterType } from '../../models/EventFilter'
import { paginate } from '../utils'

const _BASE_URL = import.meta.env.REACT_APP_API_BASE_URL!

export interface GetEventFiltersRequest extends BasePageRequest {}

export interface GetAllEventFiltersRequest extends BaseRequest {}

export interface EventFilterConditionCreate {
  type: EventFilterConditionType
  operator: EventFilterConditionOperatorType
  value: string[]
}

export interface EventFilterData {
  type: EventFilterType
  name: string
  conditions: EventFilterConditionCreate[]
}

export interface BatchUpdateEventFilterRequest extends BaseRequest {
  batch: {
    create?: EventFilterData[]
    update?: { [filterId: string]: EventFilterData }
    delete?: string[]
  }
}

export const eventFilterApi = createApi({
  reducerPath: 'eventFilterApi',
  baseQuery: baseQueryWithTokenRefresh(_BASE_URL),
  tagTypes: ['EventFilter'],
  endpoints: (builder) => ({
    getEventFilters: builder.query<BasePageResponse<EventFilter[]>, GetEventFiltersRequest>({
      query: (request) => {
        return {
          url: `/accounts/${request.accountId}/event-filters`,
          params: {
            page: request.pageRequest.page,
            size: request.pageRequest.size,
          },
        }
      },
      providesTags: ['EventFilter'],
    }),
    getAllEventFilters: builder.query<BaseResponse<EventFilter[]>, GetAllEventFiltersRequest>({
      async queryFn(request, _queryApi, _extraOptions, fetchWithBQ) {
        return await paginate<EventFilter>(
          {
            url: `/accounts/${request.accountId}/event-filters`,
          },
          fetchWithBQ,
        )
      },
      providesTags: ['EventFilter'],
    }),
    batchUpdateEventFilters: builder.mutation<void, BatchUpdateEventFilterRequest>({
      query: (request) => ({
        url: `/accounts/${request.accountId}/event-filters/batch`,
        method: 'POST',
        body: request.batch,
      }),
      invalidatesTags: ['EventFilter'],
    }),
  }),
})

export const { useGetEventFiltersQuery, useGetAllEventFiltersQuery, useBatchUpdateEventFiltersMutation } = eventFilterApi
